<template>
    <div class="article-home-privates">
        <p>Lauren is available at for one-to-one sessions, with a fun and friendly style. She can help you:</p>
        <ul>
            <li>In person at an event</li>
            <li>Online as a video call</li>
            <li>Reviewing your videos</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomePrivates',
};
</script>
